import { BaseModel } from "@blue-chip/core";

export default class News extends BaseModel {}
